import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { lastValueFrom, catchError } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { HandleError } from 'src/app/utils/network-error-handler';
import { HttpClient } from '@angular/common/http';
import { AuthSessionDto } from 'src/app/app.models';
import { RenewExpiredPasswordComponent } from './renew-expired-password.component';
import { RSAHelper } from 'src/app/utils/rsa-helper';

@Injectable({
    providedIn: 'root'
})
export class RenewExpiredPasswordService {
    componentRef: ComponentRef<RenewExpiredPasswordComponent> | null = null;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector,
        private _httpClient: HttpClient,
        private _apiService: ApiService,
        private rsaHelper: RSAHelper, 
    ) { }

    show(options: { AccessToken: string }) {
        return new Promise<boolean>((resolve, reject) => {
            if (!!this.componentRef) { reject(); return; }
            this.componentRef = this.componentFactoryResolver.resolveComponentFactory(RenewExpiredPasswordComponent).create(this.injector);
            this.componentRef.instance.accessToken = options.AccessToken;
            this.appRef.attachView(this.componentRef.hostView);
            const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            document.body.appendChild(domElem);
            this.componentRef.instance.onResult.subscribe(result => {
                this.hide();
                resolve(result);
            });
        });
    }

    hide() {
        if (!this.componentRef) { return; }
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        this.componentRef = null;
    }

    async doRenewExpiredPassword(_accessToken: string, _newPassword: string, _confirmPassword: string): Promise<any> {
        _newPassword = this.rsaHelper.encryptWithPublicKey(_newPassword);
        _confirmPassword = this.rsaHelper.encryptWithPublicKey(_confirmPassword);

        return await lastValueFrom(this._httpClient.post(this._apiService.endPoints.doRenewExpiredPasswordAction_Account, { 
            NewPassword: _newPassword, 
            ConfirmPassword: _confirmPassword 
        }, { headers: { Authorization: 'Bearer ' + _accessToken } }).pipe(catchError(error => lastValueFrom(HandleError(error)))));
    }
}